'use client'

import React, { useCallback } from 'react'

import { Button, Popover } from '@/components'
import { APP_LANGUAGES } from '@/constants'
import { useLanguages } from '@/hooks'
import { TFunc, TLang } from '@/types'

export const Languages: React.FC = () => {
  const { t, appLang, changeLanguage } = useLanguages()

  const onSelect = useCallback(
    (lang: TLang, onClose: TFunc) => () => {
      changeLanguage(lang)
      onClose()
    },
    [changeLanguage],
  )

  return (
    <Popover
      WrapEl="li"
      NestedWrapEl="div"
      nestedElementClass="languageSwitcher btn-group"
      button={
        <Button className="btn dropdown-toggle">
          <i className="language-icon"></i>
          {t(`${appLang}`)}
          <span className="caret"></span>
        </Button>
      }
    >
      {onClose => (
        <ul>
          {APP_LANGUAGES.filter(_v => _v !== appLang).map(lang => (
            <li key={lang}>
              <p onClick={onSelect(lang, onClose)}>{t(`${lang}`)}</p>
            </li>
          ))}
        </ul>
      )}
    </Popover>
  )
}
